import { Theme } from '@mui/material';
import { borderColor } from '@mui/system';

export const sxStyles = {
  bullets: {
    display: 'flex',
    gap: 1,

    '> svg': {
      height: '12px',
      width: '12px',

      '& path': {
        fill: (theme: Theme) => theme.palette.primary.main,
      },
    },
  },
};
